import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// core components
import Header from "components/Header/Header.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Parallax from "components/Parallax/Parallax.jsx";
import { API } from "aws-amplify";
import FooterSection from "./../PortalPage/Sections/FooterSection.jsx";
import BottomNavSection from "./../TenPage/Sections/BottomNavSection.jsx";

// Sections
import CourseDetailsSection from "./Sections/CourseDetailsSection.jsx";
import CourseEnrolSection from "./Sections/CourseEnrolSection.jsx";
import CourseDetailsPageStyle from "assets/jss/material-kit-pro-react/views/courseDetailsPageStyle.jsx";

class CourseDetailsPage extends React.Component {

  state = {
    course: null,
    courseiteration: [],
    sessionsData: false
  };

  async getData() {
    const courseId = this.props.match.params.courseId;
    let apiName = 'capabilityexplorer';
    let path = '/course/' + courseId;
    let myInit = { // OPTIONAL
      headers: {} // OPTIONAL
    };
    return await API.get(apiName, path, myInit);
  }

  async getCourseIterationData() {
    const courseId = this.props.match.params.courseId;
    let apiName = 'capabilityexplorer';
    let path = '/course/' + courseId + '/iteration';
    let myInit = { // OPTIONAL
      headers: {} // OPTIONAL
    };
    return await API.get(apiName, path, myInit);
  }

  componentDidMount() {
    // Get course details
    this.getData().then(response => {
      console.log("course", response);
      this.setState({
        ...this.state,
        course: response.Item
      });
      console.log("state", this.state);
    });

    this.getCourseIterationData().then(response => {
      console.log("courseiteration", response);
      this.setState({
        ...this.state,
        courseiteration: response.Items,
        sessionsData: true
      });
    });
  }

  render() {
    const { classes, ...rest } = this.props;
    const imageClasses = classNames(
      classes.imgRaised,
      classes.imgRoundedCircle,
      classes.imgFluid
    );

    return (
      <div>
        <Header
          color="transparent"
          brand="TEN Gateway"
          links={<HeaderLinks dropdownHoverColor="primary" />}
          fixed
          changeColorOnScroll={{
            height: 200,
            color: "primary"
          }}
          {...rest}
        />
        <Parallax small filter image={require("assets/img/books-shelves.jpeg")} />
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
            <div className={classes.container}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8}>
                  <div className={classes.profile}>
                    <div className={classes.name}>
                      <h1 className={classes.title}>Module</h1>
                    </div>
                  </div>
                </GridItem>
              </GridContainer>
              <CourseDetailsSection course={this.state.course} />
              <CourseEnrolSection
                courseiteration={this.state.courseiteration}
                sessionsData={this.state.sessionsData}
              />
              <BottomNavSection />
            </div>
          </div>
        </div>
        <FooterSection />
      </div>
    );
  }
}

export default withStyles(CourseDetailsPageStyle)(CourseDetailsPage);
